// Mainnets
// -------------------
export const networks = {
  mainnet: {
    chainId: '0x1',
    chainName: 'Ethereum Mainnet',
    nativeCurrency: {
      name: 'Ethereum',
      symbol: 'ETH',
      decimals: 18,
      logo: '/images/etha.webp',
    },
    rpcUrls: ['https://mainnet.infura.io/v3/'],
    blockExplorerUrls: ['https://etherscan.io'],
    logo: '/images/etha.webp',
    tokens: [
      {
        name: 'Tether',
        symbol: 'USDT',
        decimals: 6,
        address: '0xdac17f958d2ee523a2206206994597c13d831ec7',
        logo: '/images/usdt.webp',
      },
      {
        name: 'USD Coin',
        symbol: 'USDC',
        decimals: 6,
        address: '0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48',
        logo: '/images/usdc.png',
      },
    ],
  },
  bsc: {
    chainId: '0x38',
    chainName: 'Binance Smart Chain',
    nativeCurrency: {
      name: 'Binance Coin',
      symbol: 'BNB',
      decimals: 18,
      logo: '/images/bnb.png',
    },
    rpcUrls: ['https://bsc-dataseed.binance.org/'],
    blockExplorerUrls: ['https://bscscan.com'],
    logo: '/images/bnb.png',
    tokens: [
      {
        name: 'Tether',
        symbol: 'USDT',
        decimals: 18,
        address: '0x55d398326f99059fF775485246999027B3197955',
        logo: '/images/usdt.webp',
      },
    //   {
    //     name: 'USD Coin',
    //     symbol: 'USDC',
    //     decimals: 6,
    //     address: '0x8ac76a51cc950d9822d68b83fe1ad97b32cd580d',
    //     logo: '/images/usdc.png',
    //   },
    ],
  },
  polygon: {
    chainId: '0x89',
    chainName: 'POLYGON Mainnet',
    nativeCurrency: {
      name: 'POLYGON',
      symbol: 'POL',
      decimals: 18,
      logo: '/images/polygon.webp',
    },
    rpcUrls: ['https://polygon-rpc.com'],
    blockExplorerUrls: ['https://polygonscan.com'],
    logo: '/images/polygon.webp',
    tokens: [
      {
        name: 'Tether',
        symbol: 'USDT',
        decimals: 6,
        address: '0xc2132d05d31c914a87c6611c10748aeb04b58e8f',
        logo: '/images/usdt.webp',
      },
    //   {
    //     name: 'USD Coin',
    //     symbol: 'USDC',
    //     decimals: 6,
    //     address: '0x3c499c542cef5e3811e1192ce70d8cc03d5c3359',
    //     logo: '/images/usdc.png',
    //   },
    ],
  },
  arbitrum: {
    chainId: '0xa4b1',
    chainName: 'Arbitrum One',
    nativeCurrency: {
      name: 'Ethereum',
      symbol: 'ETH',
      decimals: 18,
      logo: '/images/arbitrum.webp',
    },
    rpcUrls: ['https://arb1.arbitrum.io/rpc'],
    blockExplorerUrls: ['https://arbiscan.io'],
    logo: '/images/arbitrum.webp',
    tokens: [
      {
        name: 'Tether',
        symbol: 'USDT',
        decimals: 6,
        address: '0xfd086bc7cd5c481dcc9c85ebe478a1c0b69fcbb9',
        logo: '/images/usdt.webp',
      },
    //   {
    //     name: 'USD Coin',
    //     symbol: 'USDC',
    //     decimals: 6,
    //     address: '0xaf88d065e77c8cC2239327C5EDb3A432268e5831',
    //     logo: '/images/usdc.png',
    //   },
    ],
  },
  base: {
    chainId: '0x2105', // 8453
    chainName: 'Base',
    nativeCurrency: {
      name: 'Ethereum',
      symbol: 'ETH',
      decimals: 18,
      logo: '/images/base.png',
    },
    rpcUrls: ['https://mainnet.base.org'],
    blockExplorerUrls: ['https://basescan.org'],
    logo: '/images/base.png',
    // tokens: [
    //   {
    //     name: 'Tether',
    //     symbol: 'USDT',
    //     decimals: 6,
    //     address: '0xfde4C96c8593536E31F229EA8f37b2ADa2699bb2',
    //     logo: '/images/usdt.webp',
    //   },
    //   {
    //     name: 'USD Coin',
    //     symbol: 'USDC',
    //     decimals: 6,
    //     address: '0x833589fcd6edb6e08f4c7c32d4f71b54bda02913',
    //     logo: '/images/usdc.png',
    //   },
    // ],
  },

  // Testnets
  // -------------------
  sepolia: {
    chainId: '0xaa36a7',
    chainName: 'Sepolia testnet',
    nativeCurrency: {
      name: 'Sepolia Ether',
      symbol: 'SEP',
      decimals: 18,
      logo: '/images/sepolia.png',
    },
    rpcUrls: ['https://sepolia.infura.io/v3/'],
    blockExplorerUrls: ['https://sepolia.etherscan.io'],
    logo: '/images/sepolia.png',
 
  },
  bscTestnet: {
    chainId: '0x61',
    chainName: 'BNB Testnet',
    nativeCurrency: {
      name: 'Binance Coin testnet',
      symbol: 'tBNB',
      decimals: 18,
      logo: '/images/bnb.png',
    },
    rpcUrls: ['https://data-seed-prebsc-1-s1.binance.org:8545/'],
    blockExplorerUrls: ['https://testnet.bscscan.com'],
    logo: '/images/bnb.png',
 
  },
};
